import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=12248c8e&scoped=true&"
import script from "./HtmlEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlEditor.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditor.vue?vue&type=style&index=0&id=12248c8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12248c8e",
  null
  
)

export default component.exports